import { TYPES } from "./types";
import { tkt1DevicePackService } from "../services"; 
import { setFlag } from "./miscAction";
import { CONFIGS } from "../configs";

export const getTKT1DevicePacks = (query) => async (dispatch) => {
  try {
    const result = await tkt1DevicePackService.getDevicePacks(query);
    const data = result.data.data;
    
    if (data) {
      dispatch({
        type: TYPES.ACTION_GET_TKT1_DEVICE_PACKS_SUCCESS,
        payload: {data},
      });
    } else {
      dispatch({
        type: TYPES.ACTION_GET_TKT1_DEVICE_PACKS_FAIL,
        payload: {},
      });
    }
  } catch (error) {
    dispatch({
      type: TYPES.ACTION_CALL_API_FAIL,
      payload: {
        message: error,
      },
    });
  }
};

export const getTKT1DevicePackByID = (id) => async (dispatch) => {
  try {
    const result = await tkt1DevicePackService.getDevicePackByID(id);
    const data = result.data.data;
    
    if (data) {
      dispatch({
        type: TYPES.ACTION_GET_TKT1_DEVICE_PACK_BY_ID_SUCCESS,
        payload: {data},
      });
    } else {
      dispatch({
        type: TYPES.ACTION_GET_TKT1_DEVICE_PACK_BY_ID_FAIL,
        payload: {},
      });
    }
  } catch (error) {
    dispatch({
      type: TYPES.ACTION_CALL_API_FAIL,
      payload: {
        message: error,
      },
    });
  }
};

export const getTKT1DevicePackBySN = (sn) => async (dispatch) => {
  try {
    const result = await tkt1DevicePackService.getDevicePackBySN(sn);
    const data = result.data.data;
    
    if (data) {
      dispatch({
        type: TYPES.ACTION_GET_TKT1_DEVICE_PACK_BY_SN_SUCCESS,
        payload: {data},
      });
    } else {
      dispatch({
        type: TYPES.ACTION_GET_TKT1_DEVICE_PACK_BY_SN_FAIL,
        payload: {},
      });
    }
  } catch (error) {
    dispatch({
      type: TYPES.ACTION_CALL_API_FAIL,
      payload: {
        message: error,
      },
    });
  }
};

export const getTKT1DevicePackByNetworkSN = (networkSN) => async (dispatch) => {
  try {
    const result = await tkt1DevicePackService.getDevicePackByNetworkSN(networkSN);
    const data = result.data.data;
    
    if (data) {
      dispatch({
        type: TYPES.ACTION_GET_TKT1_DEVICE_PACK_BY_NETWORK_SN_SUCCESS,
        payload: {data},
      });
    } else {
      dispatch({
        type: TYPES.ACTION_GET_TKT1_DEVICE_PACK_BY_NETWORK_SN_FAIL,
        payload: {},
      });
    }
  } catch (error) {
    dispatch({
      type: TYPES.ACTION_CALL_API_FAIL,
      payload: {
        message: error,
      },
    });
  }
};

export const getTKT1DevicePackByPCSN = (pcSN) => async (dispatch) => {
  try {
    const result = await tkt1DevicePackService.getDevicePackByPCSN(pcSN);
    const data = result.data.data;
    
    if (data) {
      dispatch({
        type: TYPES.ACTION_GET_TKT1_DEVICE_PACK_BY_PC_SN_SUCCESS,
        payload: {data},
      });
    } else {
      dispatch({
        type: TYPES.ACTION_GET_TKT1_DEVICE_PACK_BY_PC_SN_FAIL,
        payload: {},
      });
    }
  } catch (error) {
    dispatch({
      type: TYPES.ACTION_CALL_API_FAIL,
      payload: {
        message: error,
      },
    });
  }
};

export const createTKT1DevicePack = (devicePackData) => async (dispatch) => {
  try {
    const result = await tkt1DevicePackService.createDevicePack(devicePackData);
    const data = result.data.data;
    
    if (data) {
      dispatch({
        type: TYPES.ACTION_CREATE_TKT1_DEVICE_PACK_SUCCESS,
        payload: {data},
      });
    } else {
      dispatch({
        type: TYPES.ACTION_CREATE_TKT1_DEVICE_PACK_FAIL,
        payload: {},
      });
    }
  } catch (error) {
    dispatch({
      type: TYPES.ACTION_CALL_API_FAIL,
      payload: {
        message: error,
      },
    });
  }
};

export const updateTKT1DevicePack = (id, devicePackData) => async (dispatch) => {
  try {
    const result = await tkt1DevicePackService.updateDevicePack(id, devicePackData);
    const data = result.data.data;
    
    if (data) {
      dispatch({
        type: TYPES.ACTION_UPDATE_TKT1_DEVICE_PACK_SUCCESS,
        payload: {data},
      });
    } else {
      dispatch({
        type: TYPES.ACTION_UPDATE_TKT1_DEVICE_PACK_FAIL,
        payload: {},
      });
    }
  } catch (error) {
    dispatch({
      type: TYPES.ACTION_CALL_API_FAIL,
      payload: {
        message: error,
      },
    });
  }
};

export const updateTKT1DevicePackBySN = (sn, devicePackData) => async (dispatch) => {
  try {
    const result = await tkt1DevicePackService.updateDevicePackBySN(sn, devicePackData);
    const data = result.data.data;
    
    if (data) {
      dispatch({
        type: TYPES.ACTION_UPDATE_TKT1_DEVICE_PACK_BY_SN_SUCCESS,
        payload: {data},
      });
    } else {
      dispatch({
        type: TYPES.ACTION_UPDATE_TKT1_DEVICE_PACK_BY_SN_FAIL,
        payload: {},
      });
    }
  } catch (error) {
    dispatch({
      type: TYPES.ACTION_CALL_API_FAIL,
      payload: {
        message: error,
      },
    });
  }
};

export const deleteTKT1DevicePack = (id) => async (dispatch) => {
  try {
    const result = await tkt1DevicePackService.deleteDevicePack(id);
    
    if (result.data.success) {
      dispatch({
        type: TYPES.ACTION_DELETE_TKT1_DEVICE_PACK_SUCCESS,
        payload: {id},
      });
    } else {
      dispatch({
        type: TYPES.ACTION_DELETE_TKT1_DEVICE_PACK_FAIL,
        payload: {},
      });
    }
  } catch (error) {
    dispatch({
      type: TYPES.ACTION_CALL_API_FAIL,
      payload: {
        message: error,
      },
    });
  }
};

export const tkt1DevicePackAction = {
  getTKT1DevicePacks,
  getTKT1DevicePackByID,
  getTKT1DevicePackBySN,
  getTKT1DevicePackByNetworkSN,
  getTKT1DevicePackByPCSN,
  createTKT1DevicePack,
  updateTKT1DevicePack,
  updateTKT1DevicePackBySN,
  deleteTKT1DevicePack
};
